var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.98 6.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#006493;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL_-_ICONS",
    "data-name": "ALL - ICONS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.18,0H2.07a2.07,2.07,0,0,0-.69,4V3.65A1.72,1.72,0,0,1,2.07.35H5.18a1.73,1.73,0,0,1,0,3.45H2.42v.34H5.18A2.07,2.07,0,1,0,5.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.8,6.21H6.9a2.07,2.07,0,0,0,.69-4v.37A1.73,1.73,0,0,1,6.9,5.87H3.8a1.73,1.73,0,1,1,0-3.45H6.56V2.07H3.8a2.07,2.07,0,0,0,0,4.14Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlue);
export default __webpack_public_path__ + "static/media/link_blue.73e3a031b81abf75bffbfdd8fdd1ebf3.svg";
export { ForwardRef as ReactComponent };